import { Link } from "gatsby";
import React, { useState } from "react";
import styled from "styled-components";
import { device } from '../utils/device';
import LogoDark from "./main-page/LogoDark";
import LogoWhite from "./main-page/LogoWhite";
import NavbarLinks from "./NavbarLinks";

const MaxWidth = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding: 0px 80px;

  @media ${device.tablet} {
    justify-content: space-between;
    width: 100vw;
  }


  @media only screen and (min-width: 320px) and (max-width: 575px) {
    flex-direction: row-reverse;
    padding: 0px;
    justify-content: flex-end;

    a{
      justify-content: center;
    }
  }
  @media only screen and (min-width: 576px) and (max-width: 768px) {
    flex-direction: row-reverse;
    padding: 0px;
    justify-content: flex-end;

    a{
      justify-content: center;
    }
  }
  @media only screen and (min-width: 769px) and (max-width: 991px) {
    flex-direction: row-reverse;
    padding: 0px;
    justify-content: flex-end;

    a{
      justify-content: center;
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1024px) {
   padding:0 15px;
  }

  @media only screen and (min-width: 1025px) and (max-width: 1199px) {
    padding:0 15px;
  }

`;

const Navigation = styled.nav`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  background: #004385;
  box-shadow: ${props => props.dark ? '' : props.theme.shadows.card};
  justify-content: center;
  /* position: relative; */
  z-index: 100;
  align-self: center;
  height: 80px;

  @media ${device.tablet} {
    justify-content: space-between;
    position: sticky;
    height: 100px;
    width: 100vw;
    top: 0;
    left: 0;
  }
`

const LogoWrapper = styled(Link)`
  display: flex;
  justify-content: left;
  align-items: center;
  margin-right: 20px;
  width: 25%;

  img{
    height:80px;
  }

  @media ${device.tablet} {
    margin-left: 20px;
    width:100%;
  }

  @media (max-width:991px){
    margin-left: 20px;
    width:100%;
  }

`;

const Toggle = styled.div`
  display: none;
  height: 100%;
  cursor: pointer;
  padding: 0 30px;

  @media (max-width:1200px){
    width:35%;
  }
  @media ${device.tablet} {
    display: flex;
    margin-right: 0;
    width:auto;
  }

  @media (max-width:991px){
    display: flex;
    margin-right: 0;
    width:auto;
  }

  @media ${device.mobileL} {
    margin-right: 0;
  }

`

const Navbox = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
  width: 75%;

  @media ${device.tablet} {
    position: fixed;
    flex-direction: column;
    justify-content: flex-start;
    width: 100vw;
    padding-top: 30px;
    background-color: ${props => props.dark ? props.theme.colors.primary : props.theme.colors.white};
    transition: all 0.3s ease-in;
    top: 100px;
    left: ${props => (props.open ? "-110%" : "")};
    z-index: 2000;
  }

  @media (min-width: 770px) and (max-width:991px) {
    position: fixed;
    flex-direction: column;
    justify-content: flex-start;
    width: 100vw;
    padding-top: 30px;
    background-color: ${props => props.dark ? props.theme.colors.primary : props.theme.colors.white};
    transition: all 0.3s ease-in;
    top: 80px;
    left: ${props => (props.open ? "-110%" : "")};
    z-index: 2000;
  }  

  @media ${device.mobileL} {
    z-index: 2000;
  }

  @media (max-width:1200px){
    width:65%;
  }

  @media (max-width:991px){
    width:100vw;
  }

`

const Hamburger = styled.div`
  background-color: ${props => props.dark ? props.theme.colors.white : props.theme.colors.primary};
  width: 30px;
  height: 3px;
  transition: all .3s linear;
  align-self: center;
  position: relative;
  transform: ${props => (props.open ? "rotate(-45deg)" : "inherit")};
  &::before,
  &::after {
    width: 30px;
    height: 3px;
    background-color: ${props => props.dark ? props.theme.colors.white : props.theme.colors.primary};;
    content: "";
    position: absolute;
    transition: all 0.3s linear;
  }
  &::before {
    transform: ${props =>
      props.open ? "rotate(-90deg) translate(-10px, 0px)" : "rotate(0deg)"};
    top: -10px;
  }
  &::after {
    opacity: ${props => (props.open ? "0" : "1")};
    transform: ${props => (props.open ? "rotate(90deg) " : "rotate(0deg)")};
    top: 10px;
  }
`
const Navbar = (props) => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <Navigation {...props}>
      <MaxWidth>
          <LogoWrapper to="/">
          {props.dark ? <LogoWhite /> : <LogoDark />}
          </LogoWrapper>
        <Toggle
          onClick={() => setNavbarOpen(!navbarOpen)}
        >
          {navbarOpen ? <Hamburger {...props} open /> : <Hamburger {...props} />}
        </Toggle>
        {navbarOpen ? (
          <Navbox {...props}>
            <NavbarLinks {...props}/>
          </Navbox>
        ) : (
          <Navbox {...props} open> 
            <NavbarLinks {...props}/>
          </Navbox>
        )}
      </MaxWidth>
    </Navigation>
  )
}

export default Navbar;